/**
 * Slug helpers for project detail routing (/work/:slug).
 * Slugs are derived from the project title so URLs read cleanly, with a
 * fallback to the stable id. Lookups also accept the raw id so old links keep
 * working.
 */
export const slugify = (str = "") =>
    String(str)
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");

export const projectSlug = (item) => item?.slug || slugify(item?.title || item?.id || "");

export const findProjectBySlug = (items, slug) => {
    if (!Array.isArray(items) || !slug) return null;
    return (
        items.find((it) => projectSlug(it) === slug) ||
        items.find((it) => it.id === slug) ||
        null
    );
};
